module.exports = __webpack_public_path__ + "static/media/AptAutobookActive.479e09cf.svg";